import axios from "axios";
import { clearStorage, getToken } from "../../../utils/storage";
import { removeToken } from "../userReducer";

export const setHeaderRequest = (res: any) => {
  const token = getToken();
  if (token) {
    res.headers["Authorization"] = `Bearer ${token}`;
  }
  return res;
};

export const setError = (err: any) => {
  if (err.response) {
    if (err.response.status === 401) {
      removeToken();
      clearStorage();
      window.location.href = "/login";
    }
  }
  return Promise.reject(err);
};

export const setHeaderResponse = (res: any) => {
  return res;
};

export const instanceAdmin = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_ADMIN,
  timeout: 5000
})

instanceAdmin.interceptors.request.use(setHeaderRequest, setError);
instanceAdmin.interceptors.response.use(setHeaderResponse, setError);

export const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API,
  timeout: 5000
});

instance.interceptors.request.use(setHeaderRequest, setError);
instance.interceptors.response.use(setHeaderResponse, setError);

export const instanceEndUser = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_END_USER,
  timeout: 5000
});

instanceEndUser.interceptors.request.use(setHeaderRequest, setError);
instanceEndUser.interceptors.response.use(setHeaderResponse, setError);
